export default "__VITE_ASSET__B1V$YE28__"